var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcone1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 48",
    style: {
      enableBackground: "new 0 0 55 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000129204418369489512410000015745086875246685624_);}\n\t.st1{fill:#189D70;}\n\t.st2{fill:#5C3B6B;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#5C3C6B;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#189D70;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 55,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178206595382545735250000007581303591509098656_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5484",
    style: {
      clipPath: "url(#SVGID_00000178206595382545735250000007581303591509098656_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22435",
    className: "st1",
    d: "M31.4,38.3h7.2c5.3,0,9.6,4.3,9.6,9.6l0,0V48H0.7v-0.2c0-5.3,4.3-9.6,9.6-9.6h7.4 c0,2.8,2.3,5.1,5.1,5.1h3.4C29.1,43.4,31.4,41.1,31.4,38.3C31.4,38.3,31.4,38.3,31.4,38.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22436",
    className: "st2",
    d: "M17.7,34.8H2.1c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.4-5.3-9.9,3.9-16.6 c1.9-1.2,3.2-3.1,3.7-5.3c1-3.2,2.7-6.1,5-8.5c3.1-3.4,7.8-4.8,12.3-3.7c4.1,0.8,7.7,3.2,8.7,5.9c0.7,2,0.5,3.7-0.7,4.7 c-0.2,0.2-0.6,0.2-0.8-0.1s-0.2-0.6,0.1-0.8c1.1-0.9,0.6-2.7,0.4-3.4c-0.8-2.3-4.1-4.5-7.8-5.2c-4.1-1-8.4,0.3-11.2,3.4 c-2.2,2.3-3.8,5.1-4.7,8.1c-0.6,2.4-2.1,4.5-4.1,5.9C-1.5,24.3,1.7,32,2.5,33.7h15.3c0.3,0,0.6,0.3,0.6,0.6 C18.3,34.5,18,34.8,17.7,34.8C17.7,34.8,17.7,34.8,17.7,34.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22437",
    className: "st2",
    d: "M24.5,44.5c-4,0-7.3-3.3-7.3-7.3v-9.6c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0,0,0,0,0 v9.6c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2v-3.5c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v3.5 C31.8,41.2,28.5,44.5,24.5,44.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22438",
    className: "st2",
    d: "M27.8,34.6c-0.9,0-1.8-0.1-2.7-0.3c-0.3-0.1-0.5-0.4-0.4-0.7c0.1-0.3,0.4-0.5,0.7-0.4 c5.3,1.4,10.6-1.8,12-7.1c0.4-1.6,0.4-3.4,0-5l-1.8-6.5c-0.6-2.1-1.8-4-3.6-5.3c-0.3-0.2-0.3-0.5-0.1-0.8c0.2-0.3,0.5-0.3,0.8-0.1 c2,1.5,3.4,3.6,4,5.9l1.8,6.5c1.6,5.9-1.9,11.9-7.8,13.5C29.7,34.5,28.7,34.6,27.8,34.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22439",
    className: "st2",
    d: "M30.8,25.8c-0.3,0-0.7-0.1-0.9-0.3c-0.4-0.3-0.7-0.7-0.9-1.2c-0.1-0.3,0.1-0.6,0.4-0.7 s0.6,0.1,0.7,0.4c0,0,0,0,0,0c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.3,0.1,0.5,0.1c0.4-0.2,0.5-0.6,0.4-1l-0.7-2.4 c-0.1-0.3,0.1-0.6,0.4-0.7s0.6,0.1,0.7,0.4c0,0,0,0,0,0l0.7,2.4c0.4,1-0.1,2.1-1.1,2.4C31.1,25.8,31,25.8,30.8,25.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22440",
    className: "st2",
    d: "M16.9,28.1c-2.4,0-4.4-1.9-4.5-4.4c-0.1-1.5,0.6-2.9,1.7-3.8c0.1-0.1,0.3-0.1,0.4-0.1 c6.9,0.5,9.1-3.1,11.2-6.5c1.7-2.8,3.3-5.4,7.2-5.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-3.2-0.1-4.6,2.2-6.2,4.8 c-2.1,3.4-4.6,7.6-12,7.1c-0.8,0.7-1.2,1.7-1.1,2.7c0.1,1.9,1.7,3.3,3.5,3.3c0.8,0,1.6-0.4,2.2-0.9c0.2-0.2,0.6-0.2,0.8,0 c0.2,0.2,0.2,0.6,0,0.8l0,0c-0.8,0.7-1.8,1.2-2.9,1.2C17,28.1,16.9,28.1,16.9,28.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22441",
    className: "st2",
    d: "M47.7,2.6c1.6,0,3.2,0.6,4.3,1.8l0,0c2.4,2.4,2.4,6.3,0,8.7c0,0,0,0,0,0 c-1.1,1.1-2.7,1.8-4.3,1.8h-0.1c-1,0-2-0.3-2.9-0.8C44.5,14,44.2,14,44,14l-2,0.5l0.5-1.9c0.1-0.3,0-0.6-0.1-0.9 c-1.5-2.7-0.9-6.1,1.6-7.9C45.1,3,46.4,2.6,47.7,2.6 M47.7,1.4c-4,0-7.3,3.3-7.3,7.3c0,1.3,0.3,2.5,1,3.6l-0.9,3.3 c0,0.2,0,0.3,0.2,0.4c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0l3.4-0.9c1.1,0.6,2.3,0.9,3.5,0.9h0.1c1.9,0,3.7-0.7,5.1-2.1 c2.9-2.9,2.9-7.5,0-10.3c0,0,0,0,0,0l0,0C51.5,2.2,49.7,1.5,47.7,1.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22442",
    className: "st3",
    d: "M27.4,21.4c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S27.4,20.6,27.4,21.4 L27.4,21.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22443",
    className: "st3",
    d: "M35.5,19.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S35.5,18.3,35.5,19.2 L35.5,19.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22444",
    className: "st4",
    d: "M45.4,8.8c0,0.7-0.5,1.2-1.2,1.2C43.5,10,43,9.4,43,8.8c0-0.7,0.5-1.2,1.2-1.2 C44.9,7.6,45.4,8.1,45.4,8.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22445",
    className: "st4",
    d: "M48.9,8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2l0,0 C48.4,7.6,48.9,8.1,48.9,8.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22446",
    className: "st4",
    d: "M52.4,8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2l0,0 C51.9,7.6,52.4,8.1,52.4,8.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22447",
    className: "st2",
    d: "M31,29.1c-0.9,0-1.8-0.3-2.5-1c-0.2-0.2-0.3-0.6,0-0.8s0.6-0.3,0.8,0c0,0,0,0,0,0 c1,0.9,2.6,0.9,3.5-0.1c0.3-0.4,0.6-0.8,0.6-1.3c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.3,0.5,0.6C34.3,27.8,32.8,29.1,31,29.1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcone1);
export default __webpack_public_path__ + "static/media/icone-1.c94b8952b54529b992f9fa7fa56dbfe3.svg";
export { ForwardRef as ReactComponent };